import {getPageMeta} from '../../assets/components/analytics/utils';
import TrackingUtils from '../../assets/components/fsUtils/TrackingUtils';

export const headers = {
	headers: {
		Accept: 'application/json',
		'Content-Type': 'application/json'
	},
	credentials: 'include'

};

export function handleFetchedErrors(response) {
	if (!response.ok) {
		throw Error(response.statusText);
	}

	return response;
}

export function getPostId() {
	let pageInfo = document.getElementById('page-information');
	if(pageInfo) {
		let body = document.querySelector( '.fox_sectionfront .body-content');
		if(body){
			return body.getAttribute('post-id');
		}
	}

	return document.body.getAttribute('post-id');
}

function getAssetsDomain() {
	let locationName = location.hostname;

	if (locationName.match(/www.foxsports.com/)) {
		return 'https://b.fssta.com/sta/';
	}

	if (locationName.match(/wp.foxsports.com/)) {
		return 'https://b.dev.fssta.com/sta/';
	}

	return '/wp-content/themes/foxsports/assets/dist/';
}

export const assetsDomain = getAssetsDomain();

export function decodeText(text) {
	return text.replace(/\&#(\d*)\;/g, function(s) {
		return decodeTable[s] || '';
	});
}

export function decodeHtmlEntities(text) {
	return text.replace(/\&(\w*|#\d*)\;/g, function(s) {
		return HTMLEntitiesTable[s] || '';
	});
}

const HTMLEntitiesTable = {
	'&amp;' : '&',
	'&quot;': '"',
	'&#039;' : "'",
	'&lt;'  : '<',
	'&gt;'  : '>'
}

const decodeTable = {
	'&#32;': ' ',
	'&#33;': '!',
	'&#34;': '"',
	'&#35;': '#',
	'&#36;': '$',
	'&#37;': '%',
	'&#38;': '&',
	'&#39;': '\'',
	'&#40;': '(',
	'&#41;': ')',
	'&#42;': '*',
	'&#43;': '+',
	'&#44;': ',',
	'&#45;': '-',
	'&#46;': '.',
	'&#47;': '/',

	'&#8211;': '–',
	'&#8212;': '—',
	'&#8216;': '‘',
	'&#8217;': '’',
	'&#8218;': '‚',
	'&#8220;': '“',
	'&#8221;': '”',
	'&#8222;': '„',
	'&#8224;': '†',
	'&#8225;': '‡',
	'&#8226;': '•',
	'&#8230;': '…',
	'&#8240;': '‰',
	'&#8364;': '€',
	'&#8482;': '™',
};

export function parseImagesTag(text) {
	text = `<div>${text}</div>`;
	let parser = new DOMParser();

	let result = {
		srcSet: '',
		sizes: '',
		src: '',
		noscript: ''
	};

	try {
		let el = parser.parseFromString(text, 'text/html');
		let images = el.getElementsByTagName('img');

		if (images.length > 0) {
			let img = images[0];

			result.sizes = img.getAttribute('data-sizes') || img.getAttribute('sizes');
			result.srcSet = img.getAttribute('data-srcset') || img.getAttribute('srcset');
			result.src = img.getAttribute('data-src') || img.getAttribute('src');
		}

		let noscripts = el.getElementsByTagName('noscript');

		if (noscripts.length > 0) {
			let noscript = noscripts[0];

			result.noscript = noscript.innerHTML;
		}
	}
	finally {
		return result;
	}
}

export function parseSeconds(time) {
	if (!time || time.indexOf('.') === -1){
		return time;
	}

	let minutes = Math.floor(time / 60);
	let seconds = Math.floor(time - minutes * 60);

	return minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
}

function isFlashEnabledFn() {
	let hasFlash = false;

	try {
		if ((navigator.mimeTypes &&
				navigator.mimeTypes['application/x-shockwave-flash']
			) ? navigator.mimeTypes['application/x-shockwave-flash'].enabledPlugin : 0) {
			hasFlash = true;
		}
	} catch (e) {
		if (navigator.mimeTypes['application/x-shockwave-flash'] != undefined) {
			hasFlash = true;
		}
	}

	return hasFlash;
}

export const isFlashEnabled = isFlashEnabledFn();

function isTabletOrMobileFn() {
	return navigator.userAgent.match(/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini|Windows Phone/i);
}

export const isTabletOrMobile = isTabletOrMobileFn();

function getUtmTerm() {
	const pageType = getPageMeta()['page_type'];
	return (pageType == 'home') ? 'homepage' : (pageType == 'section front') ? 'sf' : 'post';
}

const UTM_TERM = getUtmTerm();

export function fbShareParselyTrackLink(e) {

	const trackingObject = {
		'utm_campaign'  : 'share_buttons',
		'utm_source'    : 'share_fb',
		'utm_medium'    : 'fscom',
		'utm_content'   : 'original_share',
		'utm_term'		: UTM_TERM
	};

	TrackingUtils.ParselyTrackLink(e, trackingObject);
}

export function getFbShareUrl(url) {
	const utmParam =
		'utm_campaign=share_buttons&utm_medium=fscom&utm_content=return_visit&utm_term=' + UTM_TERM + '&utm_source=share_fb';
	const utmUrl = url + '?' + utmParam;

	return 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(utmUrl);
}

/**
 * Get the value of a querystring
 * @param  {String} field The field to get the value of
 * @param  {String} url   The URL to get the value from (optional)
 * @return {String}       The field value
 */
export function getQueryString(field, url) {
    var href = url ? url : window.location.href;
    var reg = new RegExp( '[?&]' + field + '=([^&#]*)', 'i' );
    var string = reg.exec(href);
    return string ? string[1] : null;
}




// WEBPACK FOOTER //
// ./react-app-src/shared/utils.js